import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const additionalNotesService = {
  getAdditonalNotes: async (user, processReferenceNum, processTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/data-entry/aditional-notes/${processReferenceNum}/${processTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  saveAdditionalNotes: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/data-entry/aditional-notes/${user.id}`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },

  deleteNotes: async (user, noteId) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/data-entry/aditional-notes/${noteId}`,
        getAxiosOptions(user)
      )
    ).data
  },

  editNotes: async (user, noteId, payload) => {
    return await axios.put(
      `${NODE_BASE_URL}/data-entry/aditional-notes/${noteId}`,
      payload,
      getAxiosOptions(user)
    )
  },
}
